import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const IBTransferRequest = {
  ibTransfer: async (params) => {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return AxiosInstance.post("/ib-transfer", params, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

export default IBTransferRequest;